export default __webpack_public_path__ + "static/media/checkers-7-lqMAX.d88ad293.jpg";